import { CardContainer } from './styles';

export default CardContainer;
